import { useOktaAuth } from "@okta/okta-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import OrdersListResponse from "../../models/API/responseModels/ordersListResponse.model";
import OrderDetailResponse from "../../models/API/responseModels/onlineOrderResponseModels/orderDetailResponse.model";
import activeLabelsResponse from "../../models/API/responseModels/activeLabelsResponse.model";

function transformResponse(res: string) {
  let response = JSON.parse(res);
  if (response?.data?.orders.length > 0) {
    response = {
      ...response,
      data: {
        ...response.data,
        orders: response.data.orders.map((order: OrderDetailResponse) => ({
          ...order,
          patient: `${order.patientFirstName} ${order.patientLastName}`,
          testTypeCode: `${order.testTypes.id}`,
        })),
      },
    };
  }
  return response;
}

function useActiveLabelsList({
  params,
  updatePagination,
  sort
}: {
  params: string;
  updatePagination: ({ totalPages }: { totalPages: number }) => void;
  sort: any;
}): UseQueryResult<activeLabelsResponse> {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: ["activeLabelsList", { params, sort }],
    queryFn: ({ queryKey }) => {
      const [_key, { params, sort }]: any = queryKey;
      const sortBy: any = {
        trackingId: "trackingId",
        shippingAddress: "shippingAddress",
        recipientAddress: "recipientAddress",
        organization: "organizationId",
        labelTitle: "labelTitle",
        status: "status",
       };
       return axiosInstance
       .get(
         `/v1/fedex/active-labels${params}${
           !!sort
             ? `${params ? "&" : "?"}sortBy=${sortBy[sort.id]}&sortDirection=${
                 sort.desc ? "DESC" : "ASC"
               }`
             : ""
         }`,{
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
          // transformResponse,
        })
        .then((res) => {
          updatePagination({ totalPages: res.data.data.totalPages });
          return res.data;
        });
    },
    // staleTime: Infinity,
    enabled: !!params && !!authState?.accessToken?.accessToken,
    refetchOnReconnect: true,
  });
}

export default useActiveLabelsList;
